import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  sociallinks: any;
  mobView: boolean = false;


  currentDate: Date = new Date();


  constructor(

    private routes: ActivatedRoute,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      if (params['view-type'] === 'mobile') {
        this.mobView = true;
      } else {
        //this.mobView = window.innerWidth <= 768;
      }
    });
  }
  ngOnInit(): void {
  }
}
